import React from "react";

import { cn } from "../../../../lib/utils";
import { escutcheon } from "../../../../lib/constant";

const Escutcheon = ({ methods, isOpen: { Escutcheon } }) => {
    const { register } = methods;
    return (
        <div
            className={cn(
                "section grid grid-cols-4 overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: Escutcheon.isOpen,
                }
            )}
        >
            {escutcheon.map(({ name, img }) => (
                <div key={name} className="group">
                    <div
                        key={name}
                        className="relative flex flex-col items-center justify-center gap-2 group-has-[:checked]:bg-[#555454] p-3"
                    >
                        <img
                            className="size-14 object-contain"
                            src={`/assets/escutcheon/${img}.png`}
                            alt={name}
                        />
                        <p className="text-gray-600 text-xs group-has-[:checked]:text-white text-center">
                            {name.replace("_", " ")}
                        </p>
                        <input
                            className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                            type="radio"
                            id="type"
                            value={name}
                            {...register("escutcheon")}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Escutcheon;
